import { Responsive } from 'semantic-ui-react';

export const isMobile = () => {
	try {
		document.createEvent('TouchEvent');
		return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
	} catch (e) {
		return false;
	}
};

export const isTabletOrLess = () => {
	try {
		document.createEvent('TouchEvent');
		return window.innerWidth - Responsive.onlyTablet.maxWidth < 0
	} catch (e) {
		return false;
	}
};
